/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
    ApiUserToJSONTyped,
} from './ApiUser';

/**
 * 
 * @export
 * @interface UsersPage
 */
export interface UsersPage {
    /**
     * 
     * @type {number}
     * @memberof UsersPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof UsersPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof UsersPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiUser>}
     * @memberof UsersPage
     */
    content: Array<ApiUser>;
}

/**
 * Check if a given object implements the UsersPage interface.
 */
export function instanceOfUsersPage(value: object): value is UsersPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UsersPageFromJSON(json: any): UsersPage {
    return UsersPageFromJSONTyped(json, false);
}

export function UsersPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiUserFromJSON)),
    };
}

export function UsersPageToJSON(json: any): UsersPage {
    return UsersPageToJSONTyped(json, false);
}

export function UsersPageToJSONTyped(value?: UsersPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiUserToJSON)),
    };
}

